const plans = [
  {
    name: 'Free',
    price: '$0',
    period: 'forever',
    description: 'Perfect for side projects and MVPs',
    features: [
      'Up to 1,000 monthly active users',
      'All authentication methods',
      'Pre-built UI components',
      'Community support',
      'Basic analytics',
    ],
    cta: 'Start Free',
    ctaHref: '/signup',
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '$49',
    period: '/month',
    description: 'For growing products and teams',
    features: [
      'Up to 10,000 monthly active users',
      'Everything in Free',
      'Custom branding',
      'SSO (SAML & OIDC)',
      'Priority support',
      'Advanced analytics',
      'Webhooks',
    ],
    cta: 'Start Free Trial',
    ctaHref: '/signup?plan=pro',
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For large-scale applications',
    features: [
      'Unlimited users',
      'Everything in Pro',
      '99.99% uptime SLA',
      'Dedicated support',
      'Custom contracts',
      'On-premise option',
      'SOC 2 reports',
    ],
    cta: 'Contact Sales',
    ctaHref: '/contact?type=enterprise',
    highlighted: false,
  },
]

export function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-surface-950">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Simple, transparent pricing
          </h2>
          <p className="text-lg text-surface-400">
            Start free, upgrade when you're ready. No per-seat pricing, no surprise bills.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`card p-6 ${plan.highlighted ? 'border-brand-500 relative' : ''}`}
            >
              {plan.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-brand-600 text-white text-xs font-medium rounded-full">
                  Most Popular
                </div>
              )}
              
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-white">{plan.name}</h3>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="text-4xl font-bold text-white">{plan.price}</span>
                  <span className="text-surface-500">{plan.period}</span>
                </div>
                <p className="mt-2 text-sm text-surface-500">{plan.description}</p>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm">
                    <svg className="w-5 h-5 text-accent-emerald flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    <span className="text-surface-300">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={plan.ctaHref}
                className={`block w-full btn text-center ${plan.highlighted ? 'btn-primary' : 'btn-secondary'}`}
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-surface-500">
          All plans include: Passwordless auth, MFA, user management, and unlimited API calls
        </p>
      </div>
    </section>
  )
}

